// Registo do menu aberto: só um por vez em toda a tela. Quem abre um menu
// chama activateMenu, que fecha o que estiver aberto noutro sítio; quem fecha
// o seu chama deactivateMenu.
let activeMenu = null;

export const activateMenu = menu => {
  // Reabrir/trocar de painel dentro do MESMO dono (o compositor, por exemplo,
  // tem três painéis que já são exclusivos entre si) não pode disparar o
  // close() dele próprio — fecharia o painel que acabou de abrir.
  if (activeMenu?.owner === menu.owner) {
    activeMenu = menu;
    return;
  }
  activeMenu?.close();
  activeMenu = menu;
};

export const deactivateMenu = owner => {
  if (activeMenu?.owner === owner) {
    activeMenu = null;
  }
};
